import {useEffect, useState} from "react";
import {Box, Button, makeStyles} from "@material-ui/core";
import {
  emptyUserMetrics,
  moveNextPage,
  updateAsyncThumbnailImg,
  updateUserAttributes,
  updateUserMetrics
} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import {useDispatch, useSelector} from "react-redux";
import {initialUserMetrics} from "../../../../../store/reducers/creator/creatorExperienceBuilder";
import {getSessionParticipantsSuccess} from '../../../../../store/actions/creator/creatorExperienceManager';
import {emptyExperience} from "../../../../../store/actions/experience/experience";
import {useHistory, useLocation} from "react-router-dom";
import {initAnalysisData} from "../../../../../store/actions/creator/analysis";
import UtilService from "../../../../../helper/service";
import roles from "../../../../../helper/roles";

const useStyles = makeStyles((theme) => ({
  mainTitle: {
    fontSize: '48px',
    fontFamily: 'Spartan-bold',
    color: '#212D40',
    textAlign: 'center',
    marginTop: '-10px',
    marginBottom: 10,
    '@media only screen and (max-width: 1440px)': {
      fontSize: '35px'
    },
    '@media only screen and (max-width: 600px)': {
      fontSize: '20px'
    }
  },
  topTitle: {
    fontFamily: 'roboto-light',
    fontSize: '30px',
    color: '#717E8B',
    textAlign: 'center',
    marginTop: '60px',
    '@media only screen and (max-width: 1440px)': {
      marginTop: '40px'
    }
  },
  img: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: 480,
    height: 360,
    '@media (max-width: 860px)': {
      width: 306,
      height: 300,
    },
  },
  imgDimension: {
    width: '100%',
    height: 360
  },
  btn: {
    width: 300,
    height: 54,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 20,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
  tractBtnDiv: {
    marginTop: '24px',
    '@media only screen and (max-width: 1440px)': {
      marginTop: '0'
    }
  }
}));

const PreRecordedFinish = (Props: any) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { userMetrics, asyncThumbnailImg, page } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { sessionCode, asyncCompleted } = userMetrics;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [changeImageDimension, setChangeImageDimension] = useState(false);

  const onReStart = () => {
    dispatch(initAnalysisData());
    dispatch(getSessionParticipantsSuccess(null));
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
    if (!!loginUserData) {
      const emptyRequest = {
        temporary_value: initialUserMetrics,
        user_id: loginUserData.user_id,
      };
      dispatch(updateUserAttributes(apolloClient.client, emptyRequest));
      dispatch(moveNextPage(0));
      dispatch(emptyUserMetrics());
      Props.setFieldChange(false);
      let url = `/creator/experience-manager/participants/${sessionCode}`;
      if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
        url = `/subscriber/creator/experience-manager/participants/${sessionCode}`;
      }
      Props.setConfirmationLeavePage(url);
      dispatch(updateAsyncThumbnailImg(null));
      history.push(url);
    }
  };

  useEffect(() => {
    if (userMetrics.stimulusList && userMetrics.stimulusList.length && userMetrics.stimulusList[0].stimulus_status === 'PROCESSING-SENTTOVDO' && userMetrics.stimulusList[0].stimulus_type === "AUDIO") {
      dispatch(updateAsyncThumbnailImg('/assets/icons/experiencebuilder/video-proccesing-tv.svg'))
      setChangeImageDimension(true)
    }
  }, [userMetrics]);

  useEffect(() => {
    dispatch(emptyExperience());
  }, [dispatch]);

  useEffect(() => {
    !asyncCompleted && dispatch(moveNextPage(page - 1));
    if (history.location.hash !== '#created') {
      UtilService.addHashTag(history, location.pathname, 'created');
    }
    asyncCompleted && dispatch(updateUserMetrics('braintrust', null))
  }, []);

  return (
    <div>
      <p className={classes.topTitle}>
        Congratulations. Your event is LIVE!
      </p>
      <p className={classes.mainTitle}>
        {userMetrics.asyncExperienceName}
      </p>
      <Box justifyContent="center" display="flex">
        <img src={asyncThumbnailImg ? asyncThumbnailImg : '/assets/images/placeholder.png'} alt={'img'} className={classes.img + " " + (changeImageDimension ? classes.imgDimension : "")} />
      </Box>

      <br />

      <Box className={classes.tractBtnDiv} display='flex' flexDirection='row' alignItems='center' justifyContent='center'>
        <Button color='primary' size='large' className={classes.btn} onClick={onReStart}>
          Start Tracking Participants
        </Button>
      </Box>

    </div>
  )
}

export default PreRecordedFinish;